export const createPermissionGroupPayload = (store, { analyticsPayload: { name, permissions } }) => ({
  'Permission Group Name': name,
  'Permission Sets Included': permissions?.join(', '),
});
